/**
 * Practice-specific constants. Everything a non-developer at FFP might need
 * to change lives here.
 */

export const PRACTICE_NAME = 'Families First Pediatrics';
export const SCHEDULE_URL = 'https://ffpeds.com/schedule-appointment/';
export const WEBSITE_URL = 'https://ffpeds.com';

export const OFFICE_PHONE_DISPLAY = '(801) 254-9700';
export const OFFICE_PHONE_TEL = '+18012549700';

// TODO(FFP): replace with the dedicated lactation line (call or text) from
// the prenatal handbook once confirmed. Falls back to the office line.
export const LACTATION_PHONE_DISPLAY = '(801) 254-9700';
export const LACTATION_PHONE_TEL = '+18012549700';

export const LACTATION_TEAM_URL = 'https://ffpeds.com/pediatrics/lactation-consulting/';
